import { render, staticRenderFns } from "./ManufacturingTasksPage.vue?vue&type=template&id=18eff831&scoped=true&"
import script from "./ManufacturingTasksPage.vue?vue&type=script&lang=js&"
export * from "./ManufacturingTasksPage.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingTasksPage.vue?vue&type=style&index=0&id=18eff831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eff831",
  null
  
)

export default component.exports